/**
 * Collection of shared utils/helpers related to the login flow.
 */
import * as Cookies from "@khan/data-cookies";

import type {Role, UserRole} from "../shared/types.ts";

// a simple function to filter out things that obviously aren't valid email
// addresses
export const isValidEmail = (value: string): boolean => {
    const parts = value.split("@");
    if (parts.length !== 2) {
        return false;
    }
    if (parts[0].length < 1) {
        return false;
    }
    const period = parts[1].indexOf(".");
    if (period < 1 || period >= parts[1].length - 2) {
        return false;
    }
    return true;
};

/**
 * Convert a role to a UserRole that can be interpreted in our backend.
 * @param {Role} [role] An optional role.
 *
 * @returns {UserRole} The UserRole equivalent of the role.
 */
export const roleToUserRole = (role?: Role | null): UserRole | undefined => {
    switch (role) {
        case "teacher":
            return "TEACHER";
        case "parent":
            return "PARENT";
        case "learner":
        default:
            // We return undefined instead of null so that we don't have to
            // pass `role: null` in mocks where role is not defined.
            return undefined;
    }
};

/**
 * Set analytics cookies.
 */
export const setAnalyticsCookies = (isFirstLogin: boolean, kaid: string) => {
    if (isFirstLogin) {
        Cookies.createCookie(
            `first_login_${kaid}`,
            Cookies.CookieCategory.Performance,
            Date.now(),
        );
    } else {
        Cookies.createCookie(
            `returning_login_${kaid}`,
            Cookies.CookieCategory.Performance,
            Date.now(),
        );
    }
};
